// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__zS6cj","input":"style_input__2bBk4"};